export enum PageTab {
  Contacts = 'contacts',
  Coworkers = 'coworkers',
  Pending = 'pending',
}
